import { filter } from "lodash";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import TableColumnOrder from "../TableColumnOrder";
import Tooltips from "../../Custom Components/tooltip";
import DeleteModal from "../DeleteModal";
import { toast } from "react-toastify";
import {deleteAllContainerMasterData} from "../../../services/ContainerMasterService";
import { getUser } from "../../../services/authService";
import FactoryOutCheckModal from "../FactoryOutCheckModal";
import { ErrorMsg } from "../../../utils/validator";

function ContainerMasterActionCenter({
  date,
  setDate,
  dataExportHandler,
  type,
  allColumns,
  getToggleHideAllColumnsProps,
  filteredUserAccessData,
  globalFilter,
  setGlobalFilter,
  selectedFlatRows,
  setNoDataState,
}) {
  const [modalShow, setModalShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [deleteIdAggregate, setDeleteIdAggregate] = useState("");
  const [deleteIdFiveM, setDeleteIdFiveM] = useState("");
  const [showFactoryOutModal, setFactoryOutModal] = useState(false);

  var allowToDownload =
    filter(filteredUserAccessData, { DownLoad: 1 }).length > 0;
  var allowToDelete = filter(filteredUserAccessData, { Delete: 1 }).length > 0;

//   useEffect(() => {
 
  
// }, [selectedFlatRows]);

  const deletePlan = async () => {
    if (selectedFlatRows) {
      let deleteList = "";
      let deleteListAggregate = "";
      let deleteListFiveM = "";
      const tractorFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "TRACTOR";
      });
      
      const aggregateFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "AGGREGATE";
      });
      
      const fiveMFilterData = filter(selectedFlatRows, function (o) {
        return o.original.DataOf === "5M";
      });
     
      tractorFilterData.length === 0 ? setDeleteId("") : setDeleteId(deleteList)
      aggregateFilterData.length === 0 ? setDeleteIdAggregate("") : setDeleteIdAggregate(deleteListAggregate)
      fiveMFilterData.length === 0 ? setDeleteIdFiveM("") : setDeleteIdFiveM(deleteListFiveM)
      let err=[];

    for (let i = 0; i < tractorFilterData.length; i++) {

      if (tractorFilterData[i].original["Gate_Out_Date"] !== "") {
        err.push(tractorFilterData[i].original["Booking_Number"]);
      } else {
        deleteList += tractorFilterData[i].original["ContainerMasterId"];
        setDeleteId(deleteList);
      }
    }
    for (let i = 0; i < aggregateFilterData.length; i++) {
      
      if (aggregateFilterData[i].original["Gate_Out_Date"] !== "") {
        err.push(aggregateFilterData[i].original["Booking_Number"]);
      } else {
        deleteListAggregate +=
          aggregateFilterData[i].original["ContainerMasterId"];
          
          setDeleteIdAggregate(deleteListAggregate);
      }
    }
    for (let i = 0; i < fiveMFilterData.length; i++) {
     
      if (fiveMFilterData[i].original["Gate_Out_Date"] !=="") {
        err.push(fiveMFilterData[i].original["Booking_Number"]);
      } else {
        deleteListFiveM += fiveMFilterData[i].original["ContainerMasterId"];
        
        setDeleteIdFiveM(deleteListFiveM);
      }
    }

    if (err.length > 0) {
     
      setFactoryOutModal({
        status: true,
        msg: ErrorMsg(err),
      });
    } else {
     
      const payload = [
        {
          TractorId: deleteList,
          AggregateId: deleteListAggregate,
          FiveMId: deleteListFiveM,
          DataAvailable: "No",
          Deleted_By: getUser().uid,
        },
      ];
      
      try {
        const response = await deleteAllContainerMasterData(payload);
        setShowDeleteModal({ status: true, msg: response.data.Message });
      } catch (error) {
        toast.error(error.response.data.Message);
      }
  
 
  
  };
}
  }
  return (
    <>
      {showDeleteModal && (
        <DeleteModal
          showModal={showDeleteModal}
          hide={() => setShowDeleteModal(false)}
          dataType="Container Master"
          label="delete plan"
          date={date}
          selectedDeleteRows={selectedFlatRows}
          setNoDataState={setNoDataState}
        />
      )}
      {modalShow && (
        <TableColumnOrder
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
         <FactoryOutCheckModal
          showModal={showFactoryOutModal}
          hide={() => setFactoryOutModal(false)}
          label="change Module"
       
          
          button="ok"
          setNoDataState={setNoDataState}
         
        />
      <div className="flex-row-align-center">
        <Form.Control
          value={globalFilter || ""}
          onChange={(e) => setGlobalFilter(e.target.value)}
          className="hiden-inp"
          placeholder="search here.."
          style={{ width: "auto" }}
        />
        {type !== "month" && (
          <>
            <div
              style={{
                display: "flex",
                width: "200px",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              <strong>From-</strong>
              <Form.Control
                type="date"
                value={date.fromdate}
                onChange={(e) => {
                  if(e.target.value <= date.todate){
                    setDate({ ...date, fromdate: e.target.value })
                  }else{
                    setDate({ ...date, fromdate: date.fromdate })
                    alert('From date should not greater than To date.')
                  }
                }}
                name="fromDate"
              />
            </div>
            <div
              style={{
                display: "flex",
                width: "200px",
                alignItems: "center",
                marginLeft: "10px",
              }}
            >
              <strong>To-</strong>
              <Form.Control
                type="date"
                value={date.todate}
                onChange={(e) => {
                  if(e.target.value >= date.fromdate){
                    setDate({ ...date, todate: e.target.value })
                  }else{
                    setDate({ ...date, todate: date.todate })
                    alert('To date should not lesser than From date.')
                  }
                }}
                name="toDate"
              />
            </div>
          </>
        )}
        {allowToDownload && (
          <Tooltips content={"Export"} direction="down">
            <button
              type="button"
              className="tractorActionCenter__upload"
              onClick={() => dataExportHandler()}
            >
              <svg
                viewBox="0 0 512 512"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#000000"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  strokeLinejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <g
                    id="Page-1"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <g
                      id="Combined-Shape"
                      fill="#ffffff"
                      transform="translate(64.000000, 48.915055)"
                    >
                      <path d="M170.666667,36.418278 L170.666667,79.0849447 L42.6666667,79.0849447 L42.6666667,356.418278 L341.333333,356.418278 L341.333333,228.418278 L384,228.418278 L384,399.084945 L0,399.084945 L0,36.418278 L170.666667,36.418278 Z M313.751611,0 L414.169889,100.418278 L313.751611,200.836556 L283.581722,170.666667 L332.485,121.751 L277.333333,121.751611 C243.249474,121.751611 215.388568,148.395237 213.441977,181.991125 L213.333333,185.751611 L213.333333,292.418278 L170.666667,292.418278 L170.666667,185.751611 C170.666667,128.391511 215.942543,81.6061582 272.706355,79.1834943 L277.333333,79.0849447 L332.484,79.084 L283.581722,30.1698893 L313.751611,0 Z"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </button>
          </Tooltips>
        )}
        {allowToDelete && (
          <Tooltips content={"Delete"} direction="down">
            <button
              className="transporterActionCenter__delete"
              variant="danger"
              onClick={deletePlan}
              disabled={selectedFlatRows.length === 0 }
              id="containerBulkDelete"
              // disabled={loading}
            >
              <i class="bx bxs-trash"></i>
            </button>
          </Tooltips>
        )}
        <Tooltips content={"Column Filter"} direction="down">
          <button
            className="tableColumnFilter_btn "
            onClick={() => setModalShow(true)}
          >
            <i class="bx bx-columns tableColumnFilter"></i>
          </button>
        </Tooltips>
      </div>
    </>
  );
}

export default ContainerMasterActionCenter;
